const mockMaintenanceSchedule = [
  {
    id: "mnt-1",
    machineId: "V26-6336",
    date: "2026-02-24",
    period: "2026-W09",
    hours: 6,
    type: "Preventiva",
    notes: "Troca de componente",
  },
  {
    id: "mnt-2",
    machineId: "V28-6449",
    date: "2026-02-26",
    period: "2026-W09",
    hours: 8,
    type: "Corretiva",
    notes: "Ajuste geral",
  },
  {
    id: "mnt-3",
    machineId: "V20-6450",
    date: "2026-03-05",
    period: "2026-W10",
    hours: 4,
    type: "Preventiva",
    notes: "Inspecao",
  },
  {
    id: "mnt-4",
    machineId: "V23-6453",
    date: "2026-03-13",
    period: "2026-W11",
    hours: 3,
    type: "Setup",
    notes: "Reconfiguracao",
  },
];

export default mockMaintenanceSchedule;
